import { Flex, Form } from 'antd'
import { FormInstance } from 'antd/lib'

import {
  InternalInquiryDocumentResponse,
  InternalIssuanceDocumentResponse
} from 'src/api/requests'
import { ConsumableListCreate } from 'src/features/stock/components'

import { LocalAdminConsumableList } from './LocalAdminConsumableList'

type Props = {
  isEdit: boolean
  isSubmitted?: boolean
  data?: InternalIssuanceDocumentResponse
  issuanceData?: InternalInquiryDocumentResponse
  form: FormInstance
}

export const LocalAdminConsumableTable = ({
  isEdit,
  isSubmitted,
  data,
  issuanceData,
  form
}: Props) => {
  return (
    <>
      <Form.Item name="inquiryItems">
        <ConsumableListCreate form={form} isFinished={true} />
      </Form.Item>

      {isEdit && (
        <Flex vertical gap={16}>
          <Form.List name="medicine">
            {(fields, { add, remove }) => (
              <LocalAdminConsumableList
                issuanceData={issuanceData}
                data={data}
                form={form}
                isSubmitted={isSubmitted}
                fields={fields}
                add={add}
                remove={remove}
              />
            )}
          </Form.List>
        </Flex>
      )}
    </>
  )
}
